// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__buuuc","container":"styles_container__WCy4n","md":"styles_md__vmBvw","lg":"styles_lg___wjoL","xl":"styles_xl__HMqkN"};